import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/sagas/membershipUnits/membershipUnits";
import { isModuleActive } from "../../../utils/modules";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import TotalMembers from "./smartComponents/totalMembers";
import TotalMembersChange from "./smartComponents/totalMembersChange";
import PreviousTotalMembers from "./smartComponents/prevTotalMembers";
import NetUnits from "./smartComponents/netUnits";
import NetUnitsChange from "./smartComponents/netUnitsChange";
import PreviousNetUnits from "./smartComponents/prevNetUnits";
import YearOverYear from "./smartComponents/yearOverYear";
import FrozenMembers from "./smartComponents/frozenMembers";
import FrozenMembersChange from "./smartComponents/frozenMembersChange";
import PreviousFrozenMembers from "./smartComponents/prevFrozenMembers";
import ChurnRatePercent from "./smartComponents/churnRatePercent";
import ChurnRatePercentChange from "./smartComponents/churnRatePercentChange";
import ScheduledCancellations from "./smartComponents/scheduledCancellations";
import ScheduledCancellationsPercentChange from "./smartComponents/scheduledCancellationsPercentChange";
// import NewPayingMembers from "./smartComponents/newPayingMembers";
// import NewPayingMembersChange from "./smartComponents/newPayingMembersChange";
// import PreviousNewPayingMembers from "./smartComponents/prevNewPayingMembers";
// import CancelledPayingMembers from "./smartComponents/cancelledPayingMembers";
// import CancelledPayingMembersChange from "./smartComponents/cancelledPayingMembersChange";
// import PreviousCancelledPayingMembers from "./smartComponents/prevCancelledPayingMembers";
import TotalNewMembers from "./smartComponents/totalNewMembers";
import PreviousTotalNewMembers from "./smartComponents/prevTotalNewMembers";
import TotalNewMembersChange from "./smartComponents/totalNewMembersChange";
import CancelledMembers from "./smartComponents/cancelledMembers";
import PreviousCancelledMembers from "./smartComponents/prevCancelledMembers";
import CancelledMembersChange from "./smartComponents/cancelledMembersChange";
import NewMembers from "./smartComponents/newMembers";
import PreviousNewMembers from "./smartComponents/prevNewMembers";
import NewMembersChange from "./smartComponents/newMembersChange";
import ReactivatedMembers from "./smartComponents/reactivatedMembers";
import PreviousReactivatedMembers from "./smartComponents/prevReactivatedMembers";
import ReactivatedMembersChange from "./smartComponents/reactivatedMembersChange";
import { getToolTip } from "../../../utils/getToolTip";
import LearnMore from "../../../components/learnMore/learnMore";

export class MembershipUnitsModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initRequest: false,
      moduleHeight: 780
    };
  }

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Membership Units")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }

    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      const state = configuratorStore.getState();
      if (
        isModuleActive(state.dashboardConfigurator.preferences, "Membership Units") &
        !this.state.initRequest
      ) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    const monthSwitcherState = configuratorMonthSwitcherStore.getState();
    let previousDate = monthSwitcherState.monthSwitcher.date;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  render() {
    let previousTotalMembers = "Previous " + this.props.membersTitle;
    const { learnMoreId, title, content } = this.props.learnMore;
    let displayScheduledCancellations = this.props.displayScheduledCancellations;
    return (
      <SectionToggle
        title="Membership Units"
        learnMore={<LearnMore learnMoreId={learnMoreId} title={title} content={content} html />}
        customClass={`membershipunitsWidget ${this.props.isLoading ? "" : "active"}`}
        height={this.state.moduleHeight}
        isLoading={this.props.isLoading}
        content={
          <div>
            <div className="section-group height-175">
              <span className="width-50">
                <SectionContainer
                  title={this.props.membersTitle}
                  toolTip={this.props.totalActiveMembersToolTip}
                  toolTipId="membershipUnitTotalActiveMembers"
                >
                  <TotalMembers />
                  <TotalMembersChange />
                </SectionContainer>
              </span>
              <span className="width-50">
                <SectionContainer
                  title={previousTotalMembers}
                  toolTip={`Previous ${this.props.totalActiveMembersToolTip}`}
                  toolTipId="membershipUnitPreviousTotalActiveMembers"
                >
                  <PreviousTotalMembers />
                </SectionContainer>
              </span>
            </div>
            <div className="section-group height-175">
              {this.props.displayFrozen === true ? (
                <>
                  <span className="width-50">
                    <SectionContainer
                      title="Frozen Members"
                      toolTip={this.props.totalFrozenMembersToolTip}
                      toolTipId="membershipUnitTotalFrozenMembers"
                    >
                      <FrozenMembers />
                      <FrozenMembersChange />
                    </SectionContainer>
                  </span>
                  <span className="width-50">
                    <SectionContainer
                      title="Previous Frozen Members"
                      toolTip={`Previous ${this.props.totalFrozenMembersToolTip}`}
                      toolTipId="membershipUnitPreviousTotalFrozenMembers"
                    >
                      <PreviousFrozenMembers />
                    </SectionContainer>
                  </span>
                </>
              ) : (
                ""
              )}
            </div>

            {this.props.displayTotalNewMembers === true ? (
              <div className="section-group height-175">
                <span className="width-50">
                  <SectionContainer title="Total New Members">
                    <TotalNewMembers />
                    <TotalNewMembersChange />
                  </SectionContainer>
                </span>
                <span className="width-50">
                  <SectionContainer title="Previous Total New Members">
                    <PreviousTotalNewMembers />
                  </SectionContainer>
                </span>
              </div>
            ) : (
              ""
            )}

            {this.props.displayTotalNewMembers === true ? (
              <div className="section-group height-175">
                <span className="width-50">
                  <SectionContainer title="Cancelled Members">
                    <CancelledMembers />
                    <CancelledMembersChange />
                  </SectionContainer>
                </span>
                <span className="width-50">
                  <SectionContainer title="Previous Cancelled Members">
                    <PreviousCancelledMembers />
                  </SectionContainer>
                </span>
              </div>
            ) : (
              ""
            )}

            {this.props.displayTotalNewMembers === true ? (
              <div className="section-group height-175">
                <span className="width-50">
                  <SectionContainer title="New Members">
                    <NewMembers />
                    <NewMembersChange />
                  </SectionContainer>
                </span>
                <span className="width-50">
                  <SectionContainer title="Previous New Members">
                    <PreviousNewMembers />
                  </SectionContainer>
                </span>
              </div>
            ) : (
              ""
            )}

            {this.props.displayTotalNewMembers === true ? (
              <div className="section-group height-175">
                <span className="width-50">
                  <SectionContainer title="Rejoin Members">
                    <ReactivatedMembers />
                    <ReactivatedMembersChange />
                  </SectionContainer>
                </span>
                <span className="width-50">
                  <SectionContainer title="Previous Rejoin Members">
                    <PreviousReactivatedMembers />
                  </SectionContainer>
                </span>
              </div>
            ) : (
              ""
            )}

            <div className="section-group height-175">
              <span className="width-50">
                <SectionContainer
                  title="Net Units MTD"
                  toolTip={this.props.newUnitsToolTip}
                  toolTipId="membershipNewUnitsToolTipMTD"
                >
                  <NetUnits />
                  <NetUnitsChange />
                </SectionContainer>
              </span>
              <span className="width-50">
                <SectionContainer
                  title="Previous Net Units MTD"
                  toolTip={`Previous ${this.props.newUnitsToolTip}`}
                  toolTipId="membershipPreviousNewUnitsMTDToolTip"
                >
                  <PreviousNetUnits />
                </SectionContainer>
              </span>
            </div>

            {this.props.currentUser.sourceType === "clubready" ? (
              <div className="section-group height-175">
                <span className="width-50">
                  <SectionContainer
                    title="Attrition Rate"
                    toolTip={this.props.attritionRateToolTip}
                    toolTipId="membershipUnitAttritionRate"
                    isToolTipHtml
                  >
                    <ChurnRatePercent />
                    <ChurnRatePercentChange />
                  </SectionContainer>
                </span>
                {displayScheduledCancellations ? (
                  <span className="width-50">
                    <SectionContainer
                      title="Scheduled Cancellations"
                      toolTip={this.props.scheduledCancellationsToolTip}
                      toolTipId="scheduledCancellationsNumber"
                      isToolTipHtml
                    >
                      <ScheduledCancellations />
                      {/*<ScheduledCancellationsPercentChange />*/}
                    </SectionContainer>
                  </span>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}

            {this.props.currentUser.sourceType === "mindbody" ? (
              <div className="section-group height-175">
                <span className="width-50">
                  <SectionContainer
                    title="Attrition Rate"
                    toolTip={this.props.attritionRateToolTip}
                    toolTipId="membershipUnitAttritionRate"
                    isToolTipHtml
                  >
                    <ChurnRatePercent />
                    <ChurnRatePercentChange />
                  </SectionContainer>
                </span>
              </div>
            ) : (
              ""
            )}

            {this.props.currentUser.sourceType === "clubready" ||
            this.props.currentUser.sourceType === "mindbody" ? (
              <div className="section-group" style={{ width: "100%" }}>
                <SectionContainer title="Net Units Day Over Day">
                  <YearOverYear />
                </SectionContainer>
              </div>
            ) : (
              ""
            )}
          </div>
        }
      />
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.membershipUnits.isLoading,
    userParams: state.membershipUnits.currentUser,
    isPayingMembers: state.membershipUnits.membershipUnits.isPayingMembers,
    membersTitle: state.membershipUnits.membershipUnits.isPayingMembers
      ? "Paying Members"
      : "Total Active Members",
    attritionRateToolTip: state.membershipUnits.membershipUnits.churnRate.tooltip,
    totalActiveMembersToolTip: state.membershipUnits.membershipUnits.totalActive.tooltip,
    totalFrozenMembersToolTip: state.membershipUnits.membershipUnits.totalFrozen.tooltip,
    newUnitsToolTip: getToolTip(state.membershipUnits.membershipUnits),
    // newPayingMembersToolTip: state.membershipUnits.membershipUnits.newPayingMembers.tooltip,
    // cancelledPayingMembersToolTip: state.membershipUnits.membershipUnits.cancelledPayingMembers.tooltip,
    displayFrozen: state.membershipUnits.membershipUnits.displayFrozen,
    displayTotalNewMembers:
      state.membershipUnits.membershipUnits.totalNewMembers.displayTotalNewMembers,
    scheduledCancellationsToolTip:
      state.membershipUnits.membershipUnits.scheduledCancellations.tooltip,
    displayScheduledCancellations:
      state.membershipUnits.membershipUnits.scheduledCancellations.displayScheduledCancellations
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(MembershipUnitsModule);

MembershipUnitsModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  isPayingMembers: PropTypes.bool,
  membersTitle: PropTypes.string,
  attritionRateToolTip: PropTypes.string,
  totalActiveMembersToolTip: PropTypes.string,
  totalFrozenMembersToolTip: PropTypes.string,
  newUnitsToolTip: PropTypes.string,
  newPayingMembersToolTip: PropTypes.string,
  cancelledPayingMembersToolTip: PropTypes.string,
  learnMore: PropTypes.objectOf(PropTypes.string),
  displayFrozen: PropTypes.bool,
  displayTotalNewMembers: PropTypes.bool,
  scheduledCancellationsToolTip: PropTypes.string,
  displayScheduledCancellations: PropTypes.bool
};
